import React, { Component } from 'react';
import { ScrollView } from 'react-native';
import { createContainer } from '@dbk-legacy/muster/react';
import Spinner from '@dbk/ui-spinner';
import { NotificationWarning } from '@dbk/ui-icons';
import Text from '@dbk/ui-text';
import Bar from '../bar';
import Contacts from '../contacts';
import Messenger from '../messenger';
import ProfileBar from '../profile-bar';
import { CHAT_MSG_TYPE, CHAT_RECIPIENT_TYPE, } from '../../../../src/constants';
import WS from '../web-socket/index';
import BlurModal from '../../../../src/components/common/blur-modal';

class Widget extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showMessageThread: false,
      toUserActive: '',
      chatHistory: [],
      hideWarning: true
    };

    this.expand = this.expand.bind(this);
    this.onClose = this.onClose.bind(this);
    this.onSelectContact = this.onSelectContact.bind(this);
    this.sendMessage = this.sendMessage.bind(this);
  }

  componentWillMount() {
    this.props.connectToWebSocket();
  }

  componentDidUpdate(prevProps, prevState) {
    const { chat: { chatHistory } } = this.props;
    if (prevProps.chat.chatHistory !== chatHistory) {
      this.updateChatHistoryInState(chatHistory);
    }
  }

  updateChatHistoryInState = (chatHistory) => {
    this.setState({
      chatHistory
    });
  }

  expand() {
    const { chat: { expand, shouldExpand, setRecvNewMessage } } = this.props;
    shouldExpand(!expand);
    setRecvNewMessage(false);
  }

  onClose() {
    const { chat: {  setShowChat, closeChatWindow } } = this.props;
    setShowChat(false);
    closeChatWindow(false);
  }

  onSelectContact(user) {
    this.props.setToUserActive(user);
    this.setState({
      showMessageThread: !this.state.showMessageThread,
      toUserActive: user
    });
  }

  sendMessage(text) {
    const {
      auth: { userId },
      chat: {
        toUserActive,
        webSocket,
        chatHistory
      }
    } = this.props;

    let messageObject = {
      "fromUserId": userId,
      "toUserId": toUserActive.userId,
      "msgType": CHAT_MSG_TYPE.CHAT_MSG,
      "chatType": CHAT_RECIPIENT_TYPE.INDIVIDUAL,
      "message": text,
      "meta": null
    }

    if (typeof text === 'object') {
      messageObject = text;
    }

    try {
      if (webSocket.readyState === 1) {
        webSocket.send(JSON.stringify(messageObject));
      }
      else if (webSocket.readyState === 0) {
        setTimeout(webSocket.send(JSON.stringify(messageObject)), 500);
      }
      else {
        messageObject.sendFail = true;
      }
    } catch (err) {
      messageObject.sendFail = true;
    }
    const chats = chatHistory;
    chats.push(messageObject);
    // this.updateChatHistoryInState(chatHistory);
    this.props.setChatHistory(chats);
  }

  scrollToBottom = () => {
    if (this.rootView) {
      this.rootView.scrollToEnd();
    }
  }

  renderErrorModal = () => {
    const { chat: { chatError } } = this.props;
    return (
      <div className="row">
        <div className="small-12 text-center">
          <div className="center">
            <NotificationWarning color='#b92635' secondaryColor='#152139' width={50} height={50} />
            <div className="pad-top-25 pad-bottom-25 center">
              <div className="error-title">
                <Text secodary numberOfLines={1}>{chatError}</Text>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  /**
  * function: closeBlurModal will update the state and hide the BlurModal
  */
  closeBlurModel = () => {
    this.setState({ hideWarning: true });
    this.props.setChatError(null);
  };

  render() {
    const {
      i18n: { messages },
      chat: {
        expand,
        fetchUserList,
        loadingUserList,
        userList,
        toUserActive,
        randomString, // Need this to update chatHistory
        chatHistory,
        chatError,
        recvNewMessage
      },
      fetchChatHistory,
    } = this.props;

    return (
      <div>

        <BlurModal visible={chatError}
          doneVisible={false}
          title={messages['"app.error.errorCode.5001']}
          onDone={() => this.closeBlurModel()}
        >
          {this.renderErrorModal()}
        </BlurModal>

        <div className='chat-widget'>

          {/* <Bar notify message="New Message from Nickki"/> */}

          {!this.state.showMessageThread &&
            <div>
              <Bar notify={!expand && recvNewMessage} message={!expand && recvNewMessage} newMsgLabel={messages['app.chat.newMessage']} show={expand} onExpand={this.expand} onClose={this.onClose} />
              {expand &&
                <Contacts
                  fetchUserList={fetchUserList}
                  loading={loadingUserList}
                  userList={userList}
                  selectedContact={this.onSelectContact}
                />
              }
            </div>
          }

          {this.state.showMessageThread &&
            <div>
              <ProfileBar
                isOnline={this.state.toUserActive.online}
                name={this.state.toUserActive.userName}
                onBack={this.onSelectContact}
                onClose={this.onClose}
                hasItems={chatHistory && chatHistory.length === 0}
              />

              <Messenger
                toUserId={this.state.toUserActive.userId}
                fetchChatHistory={fetchChatHistory}
                chatHistory={chatHistory}
                message={this.sendMessage}
                scrollToBottom={this.scrollToBottom} />

            </div>
          }

        </div >

      </div>

    );
  }
}

export default createContainer({
  $queries: {
    i18n: {
      messages: true,
    },
    auth: { userId: true },
    setChatError: {
      $set: 'chat.chatError'
    },
    chat: {
      expand: true,
      shouldExpand: { $set: 'expand' },
      setRecvNewMessage: {$set: 'recvNewMessage'},
      showChat: true,
      setShowChat: { $set: 'showChat' },
      fetchUserList: { $call: 'fetchUserList' },
      loadingUserList: true,
      userList: true,
      toUserActive: true,
      chatHistory: true,
      webSocket: true,
      randomString: true,
      chatError: true,
      recvNewMessage:true,
      closeChatWindow: { $set: 'isChatSelected' }
    },
    setChatHistory: { $set: 'chat.chatHistory' },
    setToUserActive: { $set: 'chat.toUserActive' },
    fetchChatHistory: { $call: 'chat.fetchChatHistory' },
    connectToWebSocket: { $call: 'chat.connectWebSocket' }
  }
})(Widget);
